import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Divider
} from "@mui/material";
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  Timestamp,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { usePriceContext } from '../context/PriceContext';
import { subDays } from "date-fns";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import StoreIcon from '@mui/icons-material/Store'; // Şube ikonu eklendi

const db = getFirestore();
const auth = getAuth();

// --- ŞUBE LİSTESİ ---
// Buraya sistemdeki şubelerinizi ekleyin. Key: veritabanı kodu, Label: Ekranda görünecek isim.
const subeler = [
  { key: 'sefakoy_merkez', label: 'Sefaköy Merkez' },
  { key: 'sefakoy_sube', label: 'Sefaköy Şube' },
  { key: 'kavakli_sube', label: 'Kavaklı Şube' }
];

const categories = [
  {
    key: "sarrafiye",
    name: "Sarrafiye",
    field: "adet",
    urunler: [
      { key: "eskiZiynetCeyrek", label: "Eski Ziynet Çeyrek", hasCarpan: 1.61 },
      { key: "yeniZiynetCeyrek", label: "Yeni Ziynet Çeyrek", hasCarpan: 1.62 },
      { key: "eskiZiynetYarim", label: "Eski Ziynet Yarım", hasCarpan: 3.22 },
      { key: "yeniZiynetYarim", label: "Yeni Ziynet Yarım", hasCarpan: 3.24 },
      { key: "eskiZiynetTam", label: "Eski Ziynet Tam", hasCarpan: 6.44 },
      { key: "yeniZiynetTam", label: "Yeni Ziynet Tam", hasCarpan: 6.48 },
      { key: "eskiZiynetGremse", label: "Eski Ziynet 2.5’lu Gremse", hasCarpan: 16.10 },
      { key: "yeniZiynetGremse", label: "Yeni Ziynet 2.5’lu Gremse", hasCarpan: 16.20 },
      { key: "eskiZiynetBesli", label: "Eski Ziynet Beşli", hasCarpan: 32.20 },
      { key: "yeniZiynetBesli", label: "Yeni Ziynet Beşli", hasCarpan: 32.40 },
      { key: "cumhuriyetAtaCeyrek", label: "Cumhuriyet Ata Çeyrek", hasCarpan: 1.68 },
      { key: "cumhuriyetAtaYarim", label: "Cumhuriyet Ata Yarım", hasCarpan: 3.36 },
      { key: "cumhuriyetAta", label: "Cumhuriyet Ata", hasCarpan: 6.70 },
      { key: "cumhuriyetAtaGremse", label: "Cumhuriyet Ata 2.5’lu", hasCarpan: 16.75 },
      { key: "cumhuriyetAtaBesli", label: "Cumhuriyet Ata Beşli", hasCarpan: 33.50 },
      { key: "resatCeyrek", label: "Reşat Çeyrek", hasCarpan: 1.75 },
      { key: "resatYarim", label: "Reşat Yarım", hasCarpan: 3.50 },
      { key: "resat", label: "Reşat", hasCarpan: 7.00 },
      { key: "resatGremse", label: "Reşat 2.5’lu", hasCarpan: 17.50 },
      { key: "resatBesli", label: "Reşat Beşli", hasCarpan: 35.00 },
    ],
  },
  {
    key: "gramAltin",
    name: "Gram Altın",
    field: "adet",
    urunler: [
      { key: "birGram22Ayar", label: "1 Gram 22 Ayar", hasCarpan: 0.912 },
      { key: "yariGram22Ayar", label: "0.50 Gram 22 Ayar", hasCarpan: 0.456 },
      { key: "ceyrekGram22Ayar", label: "0.25 Gram 22 Ayar", hasCarpan: 0.228 },
      { key: "birGram24Ayar", label: "1 Gram 24 Ayar", hasCarpan: 0.995 },
      { key: "yariGram24Ayar", label: "0.50 Gram 24 Ayar", hasCarpan: 0.498 },
      { key: "ceyrekGram24Ayar", label: "0.25 Gram 24 Ayar", hasCarpan: 0.249 },
      { key: "ikiBucukGram24Ayar", label: "2.50 Gram 24 Ayar", hasCarpan: 2.49 },
      { key: "besGram24Ayar", label: "5 Gram 24 Ayar", hasCarpan: 4.98 },
      { key: "onGram24Ayar", label: "10 Gram 24 Ayar", hasCarpan: 9.95 },
      { key: "yirmiGram24Ayar", label: "20 Gram 24 Ayar", hasCarpan: 19.90 },
      { key: "elliGram24Ayar", label: "50 Gram 24 Ayar", hasCarpan: 49.75 },
      { key: "yuzGram24Ayar", label: "100 Gram 24 Ayar", hasCarpan: 99.50 },
    ],
  },
  {
    key: "hurda",
    name: "Hurda",
    field: "gram",
    urunler: [
      { key: "yirmiDortAyarHurda", label: "24 Ayar Hurda", hasCarpan: 0.995 },
      { key: "yirmiIkiAyarBilezikHurda", label: "22 Ayar Bilezik Hurda", hasCarpan: 0.912 },
      { key: "yirmiIkiAyarHurda", label: "22 Ayar Hurda", hasCarpan: 0.910 },
      { key: "yirmiBirAyarHurda", label: "21 Ayar Hurda", hasCarpan: 0.850 },
      { key: "onSekizAyarHurda", label: "18 Ayar Hurda", hasCarpan: 0.720 },
      { key: "onDortAyarHurda", label: "14 Ayar Hurda", hasCarpan: 0.575 },
      { key: "sekizAyarHurda", label: "8 Ayar Hurda", hasCarpan: 0.310 },
    ],
  },
  {
    key: "takiUrun",
    name: "Takı Ürün",
    field: "gram",
    urunler: [
      { key: "yirmiIkiAyarBilezik", label: "22 Ayar Bilezik", hasCarpan: 0.912 },
      { key: "onDortAyarBilezik", label: "14 Ayar Bilezik", hasCarpan: 0.575 },
      { key: "sekizAyarBilezik", label: "8 Ayar Bilezik", hasCarpan: 0.320 },
      { key: "yirmiIkiAyarTaki", label: "22 Ayar Takı", hasCarpan: 0.912 },
      { key: "yirmiBirAyarTaki", label: "21 Ayar Takı", hasCarpan: 0.860 },
      { key: "onSekizAyarTaki", label: "18 Ayar Takı", hasCarpan: 0.730 },
      { key: "onDortAyarTaki", label: "14 Ayar Takı", hasCarpan: 0.575 },
      { key: "sekizAyarTaki", label: "8 Ayar Takı", hasCarpan: 0.320 },
    ],
  },
  {
    key: "doviz",
    name: "Döviz",
    field: "adet",
    urunler: [
      { key: "tl", label: "TL - Türk Lirası", currencyCode: "TLTRY", hasCarpan: 1 },
      { key: "usd", label: "USD - Amerikan Doları", currencyCode: "USDTRY", hasCarpan: 0 },
      { key: "eur", label: "EUR - Euro", currencyCode: "EURTRY", hasCarpan: 0 },
      { key: "gbp", label: "GBP - İngiliz Sterlini", currencyCode: "GBPTRY", hasCarpan: 0 },
      { key: "chf", label: "CHF - İsviçre Frangı", currencyCode: "CHFTRY", hasCarpan: 0 },
      { key: "aud", label: "AUD - Avustralya Doları", currencyCode: "AUDTRY", hasCarpan: 0 },
      { key: "cad", label: "CAD - Kanada Doları", currencyCode: "CADTRY", hasCarpan: 0 },
      { key: "sar", label: "SAR - Suudi Arabistan Riyali", currencyCode: "SARTRY", hasCarpan: 0 },
      { key: "aed", label: "AED - Birleşik Arap Emirlikleri Dirhemi", currencyCode: "AEDTRY", hasCarpan: 0 },
      { key: "qar", label: "QAR - Katar Riyali", currencyCode: "QARTRY", hasCarpan: 0 },
      { key: "mad", label: "MAD - Fas Dirhemi", currencyCode: "MADTRY", hasCarpan: 0 },
      { key: "jod", label: "JOD - Ürdün Dinarı", currencyCode: "JODTRY", hasCarpan: 0 },
      { key: "kwd", label: "KWD - Kuveyt Dinarı", currencyCode: "KWDTRY", hasCarpan: 0 },
      { key: "cny", label: "CNY - Çin Yuanı", currencyCode: "CNYTRY", hasCarpan: 0 },
      { key: "rub", label: "RUB - Rus Rublesi", currencyCode: "RUBTRY", hasCarpan: 0 },
      { key: "bgn", label: "BGN - Bulgar Levası", currencyCode: "BGNTRY", hasCarpan: 0 },
    ],
  },
  {
    key: "genel",
    name: "Genel",
    field: "gram",
    urunler: [
      { key: "gumus", label: "Gümüş", currencyCode: "GUMUSTRY", hasCarpan: 0 },
    ],
  },
];

const normalizeString = (str) => {
  return str ? str.trim().toLocaleLowerCase('tr-TR').replace(/\s+/g, " ") : "";
};

function MagazaDurumu() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  
  // URL'den gelen sube bilgisini başlangıç değeri olarak alıyoruz
  const subeFromUrl = queryParams.get("sube")?.trim();
  const [selectedSube, setSelectedSube] = useState(subeFromUrl || (subeler.length > 0 ? subeler[0].key : ''));

  const contentRef = useRef(null);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  const [open, setOpen] = useState(false);
  const [seciliKategori, setSeciliKategori] = useState("");
  const [kasaData, setKasaData] = useState({});
  const [totalDebtGram, setTotalDebtGram] = useState(0);
  const [firmaBakiyeleri, setFirmaBakiyeleri] = useState([]); 
  const [bankaBakiyesi, setBankaBakiyesi] = useState(0); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { prices } = usePriceContext();
  const [altinTryBuy, setAltinTryBuy] = useState(0);

  // Şube değiştiğinde URL'i de güncelle (opsiyonel ama iyi olur)
  const handleSubeChange = (newSubeKey) => {
    setSelectedSube(newSubeKey);
    // URL'yi güncellemek isterseniz:
    // navigate(`?sube=${newSubeKey}`, { replace: true });
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (prices && prices.length > 0) {
      const altin = prices.find(p => p.currencyCode === "ALTINTRY");
      const xauusd = prices.find(p => p.currencyCode === "XAUUSD");
      const usdtry = prices.find(p => p.currencyCode === "USDTRY");

      let buyPrice = altin?.buy || 0;
      if (buyPrice === 0 && xauusd?.buy && usdtry?.buy) {
        buyPrice = xauusd.buy * usdtry.buy;
      }
      setAltinTryBuy(buyPrice);
    }
  }, [prices]);

  useEffect(() => {
    const fetchKasa = async () => {
      if (!selectedSube) {
        setError("Şube seçilmedi.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(""); // Hata mesajını sıfırla

        const bankaQuery = query(
          collection(db, 'subeler', selectedSube, 'islemler'),
          where('havaleEft', '>', 0)
        );
        const bankaSnapshot = await getDocs(bankaQuery);
        let totalBank = 0;
        
        bankaSnapshot.docs.forEach(doc => {
          const data = doc.data();
          const miktar = parseFloat(data.havaleEft) || 0;
          if (['Satış', 'Giriş'].includes(data.islemTuru)) {
            totalBank += miktar;
          } else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(data.islemTuru)) {
            totalBank -= miktar;
          }
        });
        setBankaBakiyesi(totalBank);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const gunsonuQuery = query(
          collection(db, "subeler", selectedSube, "gunsonukasa"),
          where("timestamp", "<", Timestamp.fromDate(today)),
          orderBy("timestamp", "desc"),
          limit(1)
        );
        const gunsonuSnapshot = await getDocs(gunsonuQuery);
        const dunkuKapanis = !gunsonuSnapshot.empty ? gunsonuSnapshot.docs[0].data() : {};

        const lastTimestamp = dunkuKapanis.timestamp || new Timestamp(0, 0);

        const islemQuery = query(
          collection(db, "subeler", selectedSube, "islemler"),
          orderBy("timestamp", "asc")
        );
        
        const snapshot = await getDocs(islemQuery);
        const islemler = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        const kasa = {};
        categories.forEach((cat) => {
          kasa[cat.key] = {};
          cat.urunler.forEach((item) => {
            kasa[cat.key][item.key] = { adet: 0, gram: 0 };
          });
        });

        // DÜZELTME 1: "genel" KATEGORİSİNİ DÜNKÜ KASADAN YÜKLEMEYİ KAPAT
        // Çünkü aşağıda tüm geçmişi baştan hesaplatacağız.
        categories.forEach((cat) => {
          if (cat.key === "takiUrun" || cat.key === "genel") return; 

          if (dunkuKapanis[cat.key]) {
            Object.keys(dunkuKapanis[cat.key]).forEach((key) => {
              if (kasa[cat.key][key] !== undefined) {
                const dunkuAdet = dunkuKapanis[cat.key]?.[key]?.adet || 0;
                const dunkuGram = dunkuKapanis[cat.key]?.[key]?.gram || 0;
                kasa[cat.key][key] = { adet: Number(dunkuAdet), gram: Number(dunkuGram) };
              }
            });
          }
        });

        const firmaMap = {}; 

        islemler.forEach((islem) => {
          const islemUrun = normalizeString(islem.urun);
          const islemKategori = normalizeString(islem.kategori);
          const adet = parseInt(islem.adet) || 0;
          const gram = parseFloat(islem.gram) || 0;
          const nakit = parseFloat(islem.nakit) || 0;
          const isTL = (islem.kategori === "Döviz" && islem.urun === "TL - Türk Lirası");

          categories.forEach((cat) => {
            const catName = normalizeString(cat.name);
            if (islemKategori === catName) {
              
              // DÜZELTME 2: "genel" KATEGORİSİ İÇİN TARİH KISITLAMASINI KALDIR
              const isTakiOrGenel = cat.key === "takiUrun" || cat.key === "genel";
              const islemMillis = islem.timestamp?.toMillis ? islem.timestamp.toMillis() : 0;
              const lastMillis = lastTimestamp?.toMillis ? lastTimestamp.toMillis() : 0;
              const isOld = islemMillis < lastMillis;

              if (!isTakiOrGenel && isOld) {
                return;
              }

              cat.urunler.forEach((item) => {
                const itemLabel = normalizeString(item.label);
                if (itemLabel === islemUrun) {
                  if (["Alış", "İade", "Değişim", "Giriş"].includes(islem.islemTuru)) {
                    if (cat.key === "sarrafiye" || cat.key === "gramAltin") {
                      kasa[cat.key][item.key].adet += adet;
                    } else if (cat.key === "takiUrun") {
                      kasa[cat.key][item.key].gram += gram * adet;
                    } else if (cat.key === "hurda" || cat.key === "genel") {
                      kasa[cat.key][item.key].gram += gram;
                    } else if (cat.key === "doviz") {
                      kasa[cat.key][item.key].adet += isTL ? nakit : adet;
                    }

                    if (!isOld) {
                      if (nakit > 0 && !isTL && kasa.doviz?.tl) kasa.doviz.tl.adet -= nakit;
                    }

                  } else if (["Satış", "Çıkış"].includes(islem.islemTuru)) {
                    if (cat.key === "sarrafiye" || cat.key === "gramAltin") {
                      kasa[cat.key][item.key].adet -= adet;
                    } else if (cat.key === "takiUrun") {
                      kasa[cat.key][item.key].gram -= gram * adet;
                    } else if (cat.key === "hurda" || cat.key === "genel") {
                      kasa[cat.key][item.key].gram -= gram;
                    } else if (cat.key === "doviz") {
                      kasa[cat.key][item.key].adet -= isTL ? nakit : adet;
                    }

                    if (!isOld) {
                      if (nakit > 0 && !isTL && kasa.doviz?.tl) kasa.doviz.tl.adet += nakit;
                    }
                  }

                  if (cat.key === "hurda" || cat.key === "takiUrun" || cat.key === "genel") {
                    kasa[cat.key][item.key].gram = Number(kasa[cat.key][item.key].gram.toFixed(2));
                  }
                  if (cat.key === "doviz") {
                    kasa[cat.key][item.key].adet = Number(kasa[cat.key][item.key].adet.toFixed(2));
                  }
                }
              });
            }
          });

          let firmaIsmi = null;
          if (islem.firma && islem.firma.firmaIsmi && islem.firma.firmaIsmi.trim()) {
            firmaIsmi = islem.firma.firmaIsmi.trim();
          }
          
          if (firmaIsmi) {
            if (!firmaMap[firmaIsmi]) {
              firmaMap[firmaIsmi] = { toplamHas: 0, odemeler15Gun: 0, sonOdeme: 0 };
            }

            const hasEsdeger = parseFloat(islem.hasEsdeger) || 0;
            const islemDate = islem.timestamp?.toDate() || new Date();

            if (hasEsdeger > 0) {
              const isGiris = ["Giriş", "Alış", "İade", "Değişim"].includes(islem.islemTuru);
              const isCikis = ["Çıkış", "Satış"].includes(islem.islemTuru);

              if (isGiris) {
                firmaMap[firmaIsmi].toplamHas += hasEsdeger;
              } else if (isCikis) {
                firmaMap[firmaIsmi].toplamHas -= hasEsdeger;
                firmaMap[firmaIsmi].sonOdeme = hasEsdeger; 

                const now = new Date();
                if (islemDate >= subDays(now, 15)) {
                  firmaMap[firmaIsmi].odemeler15Gun += hasEsdeger;
                }
              }
            }
          }
        });

        setKasaData(kasa);

        const firmaListesi = Object.entries(firmaMap).map(([firmaIsmi, veri]) => {
          const oncekiBakiye = veri.toplamHas + veri.odemeler15Gun;
          const odemeYuzdesi = oncekiBakiye > 0 ? ((veri.odemeler15Gun / oncekiBakiye) * 100).toFixed(1) : 0;
          
          return {
            firmaIsmi,
            toplamHas: parseFloat(veri.toplamHas.toFixed(2)),
            sonOdeme: veri.sonOdeme.toFixed(2),
            odemeYuzdesi
          };
        }).sort((a, b) => a.firmaIsmi.localeCompare(b.firmaIsmi));

        setFirmaBakiyeleri(firmaListesi);

        const currentTotalDebt = firmaListesi.reduce((acc, f) => acc + f.toplamHas, 0);
        setTotalDebtGram(parseFloat(currentTotalDebt.toFixed(2)));

        setLoading(false);
      } catch (err) {
        console.error("Veri çekme hatası:", err);
        setError("Veri yüklenemedi: " + err.message);
        setLoading(false);
      }
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) navigate("/login");
      else fetchKasa();
    });

    return () => unsubscribe();
  }, [selectedSube, navigate]); // sube yerine selectedSube dinleniyor

  const calculateCategoryTotalHas = (categoryKey) => {
    let total = 0;
    const cat = categories.find((c) => c.key === categoryKey);
    
    if (cat && kasaData[categoryKey]) {
      if ((categoryKey === "doviz" || categoryKey === "genel") && altinTryBuy > 0) {
        cat.urunler.forEach((item) => {
          const miktar = cat.field === "adet" 
            ? (kasaData[categoryKey]?.[item.key]?.adet || 0)
            : (kasaData[categoryKey]?.[item.key]?.gram || 0);
            
          if (miktar === 0) return;

          let tlDegeri = 0;
          if (item.currencyCode === "TLTRY") {
            tlDegeri = miktar * 1;
          } else {
            const kur = prices.find(p => p.currencyCode === item.currencyCode)?.buy || 0;
            tlDegeri = miktar * kur;
          }
          total += tlDegeri / altinTryBuy;
        });
      } else {
        cat.urunler.forEach((item) => {
          const val = cat.field === "adet"
            ? (kasaData[categoryKey][item.key]?.adet || 0)
            : (kasaData[categoryKey][item.key]?.gram || 0);
          total += val * item.hasCarpan;
        });
      }
    }
    return parseFloat(total.toFixed(2));
  };

  const bankaHasDegeri = altinTryBuy > 0 ? (bankaBakiyesi / altinTryBuy) : 0;
  
  const totalMagazaHasSermaye = categories.reduce((sum, cat) => sum + calculateCategoryTotalHas(cat.key), 0) + bankaHasDegeri;
  
  const netSermayeGram = totalMagazaHasSermaye - totalDebtGram;

  const handleClickOpen = (kategoriAdi) => {
    setSeciliKategori(kategoriAdi);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleDownloadPDF = async () => {
    const element = contentRef.current;
    if (!element) return;

    try {
      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      
      const imgWidth = 210; 
      const pageHeight = 297; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`MagazaDurumu_${selectedSube || 'Genel'}_${new Date().toLocaleDateString()}.pdf`);
    } catch (error) {
      console.error("PDF oluşturma hatası:", error);
    }
  };

  const currentCategory = categories.find((c) => c.name === seciliKategori);
  const currentTotalHas = currentCategory ? calculateCategoryTotalHas(currentCategory.key) : 0;

  if (loading || altinTryBuy === 0) {
    return (
      <Box className="mg-page mg-page--state" sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Typography variant="h6">Yükleniyor...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box className="mg-page mg-page--state" sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Typography color="error" variant="h6">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box className="mg-page" sx={{ background: "linear-gradient(165deg, #f5f2eb 0%, #ece6da 45%, #e2dacd 100%)", p: 1.2, minHeight: "73vh" }}>
      
      {/* ŞUBE SEÇİM BUTONLARI (EN ÜSTTE) */}
      <Box className="mg-sube-wrap" sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 1.6, flexWrap: 'wrap' }}>
        {subeler.map((subeItem) => (
          <Button
            key={subeItem.key}
            className="mg-sube-btn"
            variant={selectedSube === subeItem.key ? "contained" : "outlined"}
            onClick={() => handleSubeChange(subeItem.key)}
            startIcon={<StoreIcon />}
            sx={{
              fontWeight: 700,
              fontSize: '0.8rem',
              px: 2.1,
              py: 0.65,
              borderRadius: 2.5,
              background: selectedSube === subeItem.key ? 'linear-gradient(180deg, #1f2937 0%, #0f172a 100%)' : 'rgba(255,255,255,0.92)',
              color: selectedSube === subeItem.key ? '#f8fafc' : '#0f172a',
              borderColor: 'rgba(212,175,98,0.45)',
              '&:hover': {
                background: selectedSube === subeItem.key ? 'linear-gradient(180deg, #273549 0%, #152235 100%)' : '#ffffff',
                borderColor: 'rgba(212,175,98,0.62)'
              }
            }}
          >
            {subeItem.label}
          </Button>
        ))}
      </Box>

      <div ref={contentRef} className="mg-content-card" style={{ background: "linear-gradient(180deg, #fcfbf8 0%, #f5f1eb 100%)", padding: "12px", borderRadius: "12px", border: "1px solid rgba(212,175,98,0.24)", boxShadow: "0 12px 24px rgba(15,23,42,0.1)" }}>
        
        <Box className="mg-datetime" sx={{ display: "flex", justifyContent: "flex-end", mb: 1.2 }}>
          <Typography variant="body1" color="text.secondary" fontWeight="bold" sx={{ fontSize: "0.92rem" }}>
            {currentDateTime.toLocaleDateString("tr-TR")} {currentDateTime.toLocaleTimeString("tr-TR")}
          </Typography>
        </Box>

        <Typography className="mg-title" variant="h5" fontWeight={700} textAlign="center" color="#0f172a" mb={3.2}>
          Mağaza Durumu {selectedSube ? `- ${subeler.find(s => s.key === selectedSube)?.label || selectedSube.toUpperCase()}` : ""}
        </Typography>

        {/* Butonlar */}
        <Box className="mg-cat-buttons" sx={{ display: "flex", justifyContent: "center", gap: 1.2, flexWrap: "nowrap", mb: 4.2, overflowX: "auto", px: 0.5 }}>
          {categories.map((cat) => (
            <Button
              key={cat.key}
              className="mg-cat-btn"
              variant="contained"
              onClick={() => handleClickOpen(cat.name)}
              sx={{
                minWidth: 152,
                height: 78,
                fontSize: "0.92rem",
                fontWeight: 700,
                background: "linear-gradient(180deg, #1f2937 0%, #0f172a 100%)",
                border: "1px solid rgba(212,175,98,0.42)",
                "&:hover": { background: "linear-gradient(180deg, #273549 0%, #152235 100%)" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography variant="subtitle1" sx={{ mb: 0.35, fontSize: "0.94rem", fontWeight: 700 }}>
                {cat.name}
              </Typography>
              <Typography variant="caption" fontWeight="bold" sx={{ fontSize: "0.82rem" }}>
                Gram Has: {calculateCategoryTotalHas(cat.key).toFixed(2)}
              </Typography>
            </Button>
          ))}

          {/* BANKA KUTUSU */}
          <Button
            className="mg-cat-btn"
            variant="contained"
            onClick={() => handleClickOpen("BANKA")}
            sx={{
              minWidth: 152,
              height: 78,
              fontSize: "0.92rem",
              fontWeight: 700,
              background: "linear-gradient(180deg, #1f2937 0%, #0f172a 100%)",
              border: "1px solid rgba(212,175,98,0.42)",
              "&:hover": { background: "linear-gradient(180deg, #273549 0%, #152235 100%)" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="subtitle1" sx={{ mb: 0.35, fontSize: "0.94rem", fontWeight: 700 }}>
              Banka
            </Typography>
            <Typography variant="caption" fontWeight="bold" sx={{ fontSize: "0.82rem" }}>
              Gram Has: {bankaHasDegeri.toFixed(2)}
            </Typography>
          </Button>

        </Box>

        {/* Özet Kartlar */}
        <Box className="mg-summary-row" sx={{ display: "flex", justifyContent: "center", gap: 2, flexWrap: "wrap", width: "100%", mx: "auto", mb: 4.2 }}>
          <Paper className="mg-summary-card" elevation={0} sx={{ flex: 1, minWidth: 230, p: 2.2, textAlign: "center", borderRadius: 3, background: "linear-gradient(180deg, #1f2937 0%, #0f172a 100%)", color: "#f8fafc", border: "1px solid rgba(212,175,98,0.35)", boxShadow: "0 8px 20px rgba(15,23,42,0.22)" }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontSize: "0.9rem", fontWeight: 700 }}>MAĞAZA SERMAYE</Typography>
            <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "2rem" }}>{totalMagazaHasSermaye.toFixed(2)} <span style={{ fontSize: "1.2rem" }}>Gram</span></Typography>
          </Paper>
          <Paper className="mg-summary-card" elevation={0} sx={{ flex: 1, minWidth: 230, p: 2.2, textAlign: "center", borderRadius: 3, background: totalDebtGram < 0 ? "linear-gradient(180deg, #166534 0%, #14532d 100%)" : "linear-gradient(180deg, #1f2937 0%, #0f172a 100%)", color: "#f8fafc", border: "1px solid rgba(212,175,98,0.35)", boxShadow: "0 8px 20px rgba(15,23,42,0.22)" }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontSize: "0.9rem", fontWeight: 700 }}>TOPLAM BORÇ</Typography>
            <Typography variant="h4" fontWeight="bold" color={totalDebtGram < 0 ? "#c8e6c9" : "white"} sx={{ fontSize: "2rem" }}>
              {totalDebtGram.toFixed(2)} <span style={{ fontSize: "1.2rem" }}>Gram</span>
            </Typography>
          </Paper>
          <Paper className="mg-summary-card" elevation={0} sx={{ flex: 1, minWidth: 230, p: 2.2, textAlign: "center", borderRadius: 3, background: "linear-gradient(180deg, #1f2937 0%, #0f172a 100%)", color: "#f8fafc", border: "1px solid rgba(212,175,98,0.35)", boxShadow: "0 8px 20px rgba(15,23,42,0.22)" }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontSize: "0.9rem", fontWeight: 700 }}>NET SERMAYE</Typography>
            <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "2rem" }}>{netSermayeGram.toFixed(2)} <span style={{ fontSize: "1.2rem" }}>Gram</span></Typography>
          </Paper>
        </Box>

        {/* Detay Tabloları */}
        <Box className="mg-detail-section" sx={{ width: "100%", mx: "auto", mt: 4.5 }}>
          <Divider sx={{ mb: 2.8, borderColor: "#9ca3af", borderWidth: 2 }} />
          <Typography className="mg-section-title" variant="h5" fontWeight="bold" color="#0f172a" gutterBottom textAlign="center">
            Kategori Detayları
          </Typography>
          
          <Box className="mg-cat-columns" sx={{ display: "flex", gap: 1, alignItems: "stretch", overflowX: "auto" }}>
            {categories.map((cat) => {
              const catTotalHas = calculateCategoryTotalHas(cat.key);
              return (
                <Box key={cat.key} className="mg-cat-col" sx={{ flex: 1, minWidth: "145px", display: "flex", flexDirection: "column" }}>
                  <TableContainer className="mg-cat-table-wrap" component={Paper} elevation={0} sx={{ height: '100%', display: 'flex', flexDirection: 'column', border: "1px solid rgba(212,175,98,0.22)", boxShadow: "0 8px 20px rgba(15,23,42,0.08)" }}>
                    <Box sx={{ p: 1, background: "linear-gradient(180deg, #111827 0%, #0b1220 100%)", color: "#f8fafc" }}>
                      <Typography variant="subtitle1" fontWeight="bold" align="center" sx={{ fontSize: "0.82rem" }}>{cat.name}</Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}> 
                      <Table className="mg-cat-table" size="small">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#e0e0e0" }}>
                            <TableCell sx={{ fontWeight: "bold", fontSize: "0.75rem", padding: "4px" }}>Ürün</TableCell>
                            <TableCell sx={{ fontWeight: "bold", fontSize: "0.75rem", padding: "4px" }} align="right">{cat.field === "adet" ? "Adet" : "Gram"}</TableCell>
                            <TableCell sx={{ fontWeight: "bold", fontSize: "0.75rem", padding: "4px" }} align="right">Has</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {cat.urunler.map((urun) => {
                            const item = kasaData[cat.key]?.[urun.key] || { adet: 0, gram: 0 };
                            const miktar = cat.field === "adet" ? item.adet : item.gram;
                            const has = (cat.key === "doviz" || cat.key === "genel")
                              ? (miktar * (urun.hasCarpan === 1 ? 1 : prices.find(p => p.currencyCode === urun.currencyCode)?.buy || 0) / altinTryBuy).toFixed(2)
                              : (miktar * urun.hasCarpan).toFixed(2);
                            
                            return (
                              <TableRow key={urun.key} className="mg-cat-data-row">
                                <TableCell className="mg-cat-cell-product" data-label="Ürün" sx={{ fontSize: "0.75rem", padding: "4px" }}>{urun.label}</TableCell>
                                <TableCell className="mg-cat-cell-qty" data-label={cat.field === "adet" ? "Adet" : "Gram"} align="right" sx={{ fontSize: "0.75rem", padding: "4px" }}>
                                  {miktar.toFixed(cat.key === "doviz" || cat.field === "gram" ? 2 : 0)}
                                </TableCell>
                                <TableCell className="mg-cat-cell-has" data-label="Has" align="right" sx={{ fontWeight: "bold", fontSize: "0.75rem", padding: "4px" }}>
                                  {has}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Box>
                    <Box className="mg-cat-total-wrap" sx={{ mt: 'auto' }}> 
                      <Table className="mg-cat-total-table" size="small">
                         <TableBody>
                          <TableRow className="mg-cat-total-row" sx={{ backgroundColor: "#e3f2fd" }}>
                            <TableCell className="mg-cat-total-label" data-label="Toplam" sx={{ fontWeight: "bold", color: "#1565c0", fontSize: "0.75rem", padding: "4px" }}>TOPLAM HAS</TableCell>
                            <TableCell className="mg-cat-total-value" data-label="Has" align="right" sx={{ fontWeight: "bold", color: "#d32f2f", fontSize: "0.75rem", padding: "4px" }}>
                              {catTotalHas.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>
                  </TableContainer>
                </Box>
              );
            })}
          </Box>
        </Box>

        {/* Firma Bakiyeleri */}
        <Box className="mg-firma-section" sx={{ width: "100%", mx: "auto", mt: 4.5 }}>
          <Divider sx={{ mb: 2.8, borderColor: "#9ca3af", borderWidth: 2 }} />
          <Typography className="mg-section-title" variant="h5" fontWeight="bold" color="#0f172a" gutterBottom>
            Firma Bakiyeleri
          </Typography>
          <TableContainer className="mg-firma-table-wrap" component={Paper} elevation={0} sx={{ border: "1px solid rgba(212,175,98,0.22)", boxShadow: "0 10px 24px rgba(15,23,42,0.1)" }}>
            <Table className="mg-firma-table" size="small">
              <TableHead>
                <TableRow sx={{ background: "linear-gradient(180deg, #111827 0%, #0b1220 100%)" }}>
                  <TableCell sx={{ color: "#f8fafc", fontWeight: 800 }}>Firma</TableCell>
                  <TableCell sx={{ color: "#f8fafc", fontWeight: 800 }} align="right">Bakiye (g)</TableCell>
                  <TableCell sx={{ color: "#f8fafc", fontWeight: 800 }} align="center">Son Ödeme (g)</TableCell>
                  <TableCell sx={{ color: "#f8fafc", fontWeight: 800 }} align="center">Ödeme (%)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {firmaBakiyeleri.length > 0 ? (
                  firmaBakiyeleri.map((f) => (
                    <TableRow key={f.firmaIsmi} className="mg-firma-data-row" sx={{ '&:nth-of-type(odd)': { bgcolor: '#f1f5f9' } }}>
                      <TableCell className="mg-firma-cell-name" data-label="Firma" sx={{ fontWeight: 600 }}>{f.firmaIsmi}</TableCell>
                      <TableCell className="mg-firma-cell-balance" data-label="Bakiye" align="right" sx={{ fontWeight: "bold", color: f.toplamHas < 0 ? "#166534" : "#d32f2f" }}>
                        {f.toplamHas.toFixed(2)}
                      </TableCell>
                      <TableCell className="mg-firma-cell-payment" data-label="Son Ödeme" align="center">{f.sonOdeme}</TableCell>
                      <TableCell className="mg-firma-cell-percent" data-label="Ödeme %" align="center">
                        <Chip
                          label={`%${f.odemeYuzdesi}`}
                          color={parseFloat(f.odemeYuzdesi) >= 80 ? "success" : parseFloat(f.odemeYuzdesi) >= 50 ? "warning" : "error"}
                          size="small"
                          sx={{ height: 20, fontSize: "0.75rem" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">Firma kaydı bulunamadı.</TableCell>
                  </TableRow>
                )}
                <TableRow className="mg-firma-total-row" sx={{ bgcolor: "#e2e8f0", borderTop: "2px solid #64748b" }}>
                  <TableCell className="mg-firma-total-label" data-label="Toplam" sx={{ fontWeight: "bold", fontSize: "1rem" }}>GENEL TOPLAM</TableCell>
                  <TableCell className="mg-firma-total-value" data-label="Bakiye" align="right" sx={{ fontWeight: "bold", fontSize: "1rem", color: totalDebtGram < 0 ? "#166534" : "#d32f2f" }}>
                    {totalDebtGram.toFixed(2)}
                  </TableCell>
                  <TableCell colSpan={2} />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

      </div>

      <Box className="mg-pdf-row" sx={{ display: "flex", justifyContent: "center", mt: 3.8, mb: 2 }}>
        <Button 
          className="mg-pdf-btn"
          variant="contained" 
          startIcon={<PictureAsPdfIcon />} 
          onClick={handleDownloadPDF}
          sx={{
            padding: "9px 26px",
            fontSize: "1rem",
            fontWeight: 700,
            borderRadius: 2.5,
            background: "linear-gradient(180deg, #1f2937 0%, #0f172a 100%)",
            border: "1px solid rgba(212,175,98,0.4)",
            "&:hover": { background: "linear-gradient(180deg, #273549 0%, #152235 100%)" }
          }}
        >
          PDF İNDİR
        </Button>
      </Box>

      {/* MODAL (AÇILAN PENCERE) */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        className="mg-detail-dialog"
        PaperProps={{ className: "mg-detail-dialog-paper" }}
      >
        <DialogTitle className="mg-detail-dialog-title" sx={{ background: "linear-gradient(180deg, #111827 0%, #0b1220 100%)", color: "#f8fafc", textAlign: "center", fontWeight: "bold" }}>
          {seciliKategori === "BANKA" ? "Banka Kasa Durumu" : `${seciliKategori} Kasa Durumu`}
        </DialogTitle>
        <DialogContent className="mg-detail-dialog-content" dividers>
          <TableContainer className="mg-dialog-table-wrap">
            <Table className="mg-dialog-table" size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#e0e0e0" }}>
                  <TableCell sx={{ fontWeight: "bold" }}>Ürün Adı</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">
                    {seciliKategori === "BANKA" ? "Miktar (TL)" : (currentCategory?.field === "adet" ? "Adet" : "Gram")}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">Has Çarpanı</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">Has (Gram)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* EĞER BANKA İSE ÖZEL GÖSTERİM */}
                {seciliKategori === "BANKA" ? (
                  <>
                    <TableRow>
                      <TableCell>Banka Mevcut TL</TableCell>
                      <TableCell align="right">{bankaBakiyesi.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</TableCell>
                      <TableCell align="right">{(1 / altinTryBuy).toFixed(8)}</TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold", color: "#d32f2f" }}>{bankaHasDegeri.toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                      <TableCell colSpan={3} sx={{ fontWeight: "bold", color: "#1565c0" }}>TOPLAM HAS</TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold", color: "#d32f2f", fontSize: "1.1rem" }}>
                        {bankaHasDegeri.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  /* NORMAL KATEGORİ GÖSTERİMİ */
                  <>
                    {currentCategory?.urunler.map((urun) => {
                      const item = kasaData[currentCategory.key]?.[urun.key] || { adet: 0, gram: 0 };
                      const miktar = currentCategory.field === "adet" ? item.adet : item.gram;
                      const has = (currentCategory.key === "doviz" || currentCategory.key === "genel")
                        ? (miktar * (urun.hasCarpan === 1 ? 1 : prices.find(p => p.currencyCode === urun.currencyCode)?.buy || 0) / altinTryBuy).toFixed(2)
                        : (miktar * urun.hasCarpan).toFixed(2);
                      return (
                        <TableRow key={urun.key}>
                          <TableCell>{urun.label}</TableCell>
                          <TableCell align="right">
                            {miktar.toFixed(currentCategory.key === "doviz" || currentCategory.field === "gram" ? 2 : 0)}
                          </TableCell>
                          <TableCell align="right">
                            {(currentCategory.key === "doviz" || currentCategory.key === "genel") 
                                ? (urun.hasCarpan === 1 ? "1.0000" : (prices.find(p => p.currencyCode === urun.currencyCode)?.buy || 0).toFixed(4)) 
                                : urun.hasCarpan.toFixed(4)
                            }
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold", color: "#d32f2f" }}>
                            {has}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                      <TableCell colSpan={3} sx={{ fontWeight: "bold", color: "#1565c0" }}>TOPLAM HAS</TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold", color: "#d32f2f", fontSize: "1.1rem" }}>
                        {currentTotalHas.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
      <style>{`
        /* --- MOBİL: Mağaza Durumu (masaüstü sx stillerine dokunulmaz) --- */
        @media (max-width: 1649px), (max-width: 1400px) and (any-pointer: coarse) {
          .mg-page {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            min-height: 0 !important;
            height: auto !important;
            overflow-x: hidden !important;
            padding: 6px 8px 80px !important;
            box-sizing: border-box !important;
          }

          .mg-page--state {
            min-height: 50vh !important;
            height: auto !important;
            padding: 24px 12px !important;
          }

          .mg-sube-wrap {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 8px !important;
            margin-bottom: 12px !important;
            width: 100% !important;
            max-width: 100% !important;
          }

          .mg-sube-wrap .mg-sube-btn {
            width: 100% !important;
            min-height: 44px !important;
            margin: 0 !important;
          }

          .mg-content-card {
            width: 100% !important;
            max-width: 100% !important;
            padding: 10px 8px !important;
            border-radius: 10px !important;
            overflow-x: hidden !important;
            box-sizing: border-box !important;
          }

          .mg-datetime {
            justify-content: center !important;
            margin-bottom: 8px !important;
            width: 100% !important;
            max-width: 100% !important;
          }

          .mg-datetime .MuiTypography-root {
            font-size: 0.82rem !important;
            text-align: center !important;
            word-break: break-word !important;
          }

          .mg-title {
            font-size: 1.15rem !important;
            line-height: 1.3 !important;
            margin-bottom: 16px !important;
            padding: 0 4px !important;
            word-break: break-word !important;
          }

          .mg-cat-buttons {
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
            overflow-x: hidden !important;
            margin-bottom: 20px !important;
            padding: 0 !important;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
          }

          .mg-cat-buttons .mg-cat-btn {
            min-width: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
            height: auto !important;
            min-height: 64px !important;
            padding: 10px 8px !important;
            box-sizing: border-box !important;
          }

          .mg-cat-buttons .mg-cat-btn .MuiTypography-subtitle1 {
            font-size: 0.82rem !important;
            word-break: break-word !important;
          }

          .mg-cat-buttons .mg-cat-btn .MuiTypography-caption {
            font-size: 0.72rem !important;
            word-break: break-word !important;
          }

          .mg-summary-row {
            flex-direction: column !important;
            gap: 10px !important;
            margin-bottom: 20px !important;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
          }

          .mg-summary-row .mg-summary-card {
            min-width: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
            flex: none !important;
            padding: 16px 12px !important;
            box-sizing: border-box !important;
            overflow: hidden !important;
          }

          .mg-summary-row .mg-summary-card .MuiTypography-h4 {
            font-size: 1.5rem !important;
            word-break: break-word !important;
          }

          .mg-detail-section,
          .mg-firma-section {
            margin-top: 24px !important;
            width: 100% !important;
            max-width: 100% !important;
            overflow-x: hidden !important;
            box-sizing: border-box !important;
          }

          .mg-section-title {
            font-size: 1.1rem !important;
            text-align: center !important;
            margin-bottom: 12px !important;
            padding: 0 4px !important;
            word-break: break-word !important;
          }

          .mg-detail-section .MuiDivider-root,
          .mg-firma-section .MuiDivider-root {
            width: 100% !important;
            max-width: 100% !important;
          }

          .mg-cat-columns {
            flex-direction: column !important;
            overflow-x: hidden !important;
            gap: 12px !important;
            width: 100% !important;
            max-width: 100% !important;
          }

          .mg-cat-col {
            min-width: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
            flex: none !important;
            overflow: hidden !important;
          }

          .mg-cat-table-wrap {
            width: 100% !important;
            max-width: 100% !important;
            overflow-x: hidden !important;
            box-sizing: border-box !important;
          }

          .mg-cat-table-wrap > .MuiBox-root:first-of-type .MuiTypography-root {
            word-break: break-word !important;
            font-size: 0.8rem !important;
          }

          .mg-cat-table,
          .mg-cat-total-table,
          .mg-firma-table {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            table-layout: fixed !important;
          }

          .mg-cat-table .MuiTableCell-root,
          .mg-cat-total-table .MuiTableCell-root,
          .mg-firma-table .MuiTableCell-root {
            min-width: 0 !important;
            max-width: 100% !important;
          }

          .mg-cat-table thead,
          .mg-firma-table thead {
            display: none !important;
          }

          .mg-cat-table tbody,
          .mg-cat-total-table tbody,
          .mg-firma-table tbody {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
          }

          .mg-cat-table tbody tr.mg-cat-data-row {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            margin-bottom: 6px !important;
            border: 1px solid #e5e7eb !important;
            border-radius: 8px !important;
            overflow: hidden !important;
            background: #fff !important;
            box-sizing: border-box !important;
          }

          .mg-cat-table tbody tr.mg-cat-data-row td {
            display: grid !important;
            grid-template-columns: minmax(0, 38%) minmax(0, 1fr) !important;
            gap: 8px !important;
            align-items: center !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            padding: 8px 10px !important;
            border: none !important;
            border-bottom: 1px solid #f1f5f9 !important;
            text-align: right !important;
            font-size: 12px !important;
            word-break: break-word !important;
            overflow-wrap: anywhere !important;
            box-sizing: border-box !important;
          }

          .mg-cat-table tbody tr.mg-cat-data-row td:last-child {
            border-bottom: none !important;
          }

          .mg-cat-table tbody tr.mg-cat-data-row td::before {
            content: attr(data-label) !important;
            font-weight: 700 !important;
            color: #64748b !important;
            font-size: 11px !important;
            text-align: left !important;
            margin-right: 0 !important;
            min-width: 0 !important;
            word-break: break-word !important;
          }

          .mg-cat-total-wrap {
            width: 100% !important;
            max-width: 100% !important;
            overflow: hidden !important;
          }

          .mg-cat-total-row {
            display: flex !important;
            flex-direction: row !important;
            justify-content: space-between !important;
            align-items: center !important;
            width: 100% !important;
            max-width: 100% !important;
            padding: 10px 12px !important;
            border-radius: 8px !important;
            box-sizing: border-box !important;
            gap: 8px !important;
          }

          .mg-cat-total-row td {
            display: block !important;
            width: auto !important;
            min-width: 0 !important;
            padding: 0 !important;
            border: none !important;
            font-size: 13px !important;
            word-break: break-word !important;
          }

          .mg-cat-total-row .mg-cat-total-label {
            flex: 1 1 auto !important;
            min-width: 0 !important;
            text-align: left !important;
          }

          .mg-cat-total-row .mg-cat-total-value {
            flex: 0 0 auto !important;
            text-align: right !important;
          }

          .mg-cat-total-row .mg-cat-total-label::before,
          .mg-cat-total-row .mg-cat-total-value::before {
            display: none !important;
          }

          .mg-firma-table-wrap {
            width: 100% !important;
            max-width: 100% !important;
            overflow-x: hidden !important;
            box-sizing: border-box !important;
          }

          .mg-firma-table tbody tr.mg-firma-data-row {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            margin-bottom: 8px !important;
            border: 1px solid rgba(212, 175, 98, 0.22) !important;
            border-radius: 10px !important;
            overflow: hidden !important;
            background: #fff !important;
            box-sizing: border-box !important;
          }

          .mg-firma-table tbody tr.mg-firma-data-row:nth-of-type(odd),
          .mg-firma-table tbody tr.mg-firma-data-row:nth-of-type(even) {
            background-color: #fff !important;
          }

          .mg-firma-table tbody tr.mg-firma-data-row td {
            display: grid !important;
            grid-template-columns: minmax(0, 38%) minmax(0, 1fr) !important;
            gap: 10px !important;
            align-items: center !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            padding: 10px 12px !important;
            border: none !important;
            border-bottom: 1px solid #f1f5f9 !important;
            text-align: right !important;
            font-size: 13px !important;
            word-break: break-word !important;
            overflow-wrap: anywhere !important;
            box-sizing: border-box !important;
          }

          .mg-firma-table tbody tr.mg-firma-data-row td:last-child {
            border-bottom: none !important;
          }

          .mg-firma-table tbody tr.mg-firma-data-row td::before {
            content: attr(data-label) !important;
            font-weight: 700 !important;
            color: #64748b !important;
            font-size: 12px !important;
            text-align: left !important;
            margin-right: 0 !important;
            min-width: 0 !important;
          }

          .mg-firma-total-row {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            margin-top: 4px !important;
            border: 2px solid #64748b !important;
            border-radius: 10px !important;
            overflow: hidden !important;
            box-sizing: border-box !important;
          }

          .mg-firma-total-row td {
            display: grid !important;
            grid-template-columns: minmax(0, 38%) minmax(0, 1fr) !important;
            gap: 10px !important;
            align-items: center !important;
            width: 100% !important;
            max-width: 100% !important;
            padding: 12px !important;
            border: none !important;
            font-size: 14px !important;
            box-sizing: border-box !important;
          }

          .mg-firma-total-row td[colspan] {
            display: none !important;
          }

          .mg-firma-total-row td::before {
            content: attr(data-label) !important;
            font-weight: 700 !important;
            color: #64748b !important;
            font-size: 12px !important;
            text-align: left !important;
            margin-right: 0 !important;
          }

          .mg-pdf-row {
            margin-top: 20px !important;
            padding: 0 4px !important;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
          }

          .mg-pdf-btn {
            width: 100% !important;
            max-width: 100% !important;
            min-height: 44px !important;
          }

          .mg-detail-dialog-paper {
            margin: 0 !important;
            width: 100% !important;
            max-width: 100% !important;
            height: 100svh !important;
            max-height: 100svh !important;
            border-radius: 0 !important;
            overflow-x: hidden !important;
          }

          .mg-detail-dialog-title {
            font-size: 1rem !important;
            padding: 12px 16px !important;
            word-break: break-word !important;
          }

          .mg-detail-dialog-content {
            padding: 8px !important;
            overflow: hidden !important;
            display: flex !important;
            flex-direction: column !important;
            flex: 1 !important;
            min-height: 0 !important;
            max-width: 100% !important;
          }

          .mg-dialog-table-wrap {
            overflow-x: auto !important;
            overflow-y: auto !important;
            flex: 1 !important;
            min-height: 0 !important;
            max-width: 100% !important;
            -webkit-overflow-scrolling: touch;
          }

          .mg-dialog-table {
            min-width: 520px !important;
          }

          .mg-dialog-table .MuiTableCell-root {
            font-size: 12px !important;
            padding: 6px 4px !important;
          }
        }
      `}</style>
    </Box>
  );
}

export default MagazaDurumu;